import React from 'react';
import { useQuery } from '@apollo/client';
import FetchUserMealsQuery from './FetchUserMealsQuery';

type result = {
  loading: boolean;
  userMeals?: any;
  aiAccess?: boolean;
  dietAccess?: boolean;
};

interface IFetchUserMealsConnectorApolloProps {
  children: (result: result) => React.ReactElement;
}

export const FetchUserMealsConnectorApollo: React.FC<IFetchUserMealsConnectorApolloProps> = ({
  children,
}) => {
  const { loading, data, error } = useQuery(FetchUserMealsQuery);

  const result: result = {
    loading,
  };

  if (error) {
    throw error;
  }

  if (!loading) {
    const todayDateString = new Date().toISOString().slice(0, 10);
    const dietAccessTo = data.me?.diet?.accessTo;
    const hasDietAccess = Boolean(dietAccessTo) && dietAccessTo >= todayDateString;
    result.userMeals = data.dailyTracker.userMeals.edges.map((edge: any) => edge.node);
    result.aiAccess = data.me.aiAccess.hasAccess;
    result.dietAccess = hasDietAccess;
  }

  return children(result);
};

export default FetchUserMealsConnectorApollo;
